import { useNavigate } from "react-router-dom";
import { use, useEffect, useState } from "react";
import True_False from "../CartComponents/True_False";
import Listen_find from "../CartComponents/Listen_find";
import Answer_question from "../CartComponents/Answer_question";
import { useSelector } from "react-redux";
import SEOHead from "../CommanComponents/SEOHead";

function ExtraTaskPage() {
  const contentValue = useSelector((state) => state.extra.value);
  const currentActiveId = useSelector((state) => state.extralessanTask.value);
  const dynamicPicture = `/extapicture/${contentValue.picture}`;
  const [tab, settab] = useState(0);
  const navigate = useNavigate();
  useEffect(() => {
    // contentValue boş veya tanımsız veya uzunluğu 0 ise ana sayfaya yönlendir
    if (!contentValue || contentValue.length === 0) {
      console.log("İçerik boş, ana sayfaya yönlendiriliyor...");
      navigate("/cartPage");
    }
  }, [contentValue, navigate]);
  return (
    <div
      className="flex flex-col   justify-center items-center  gap-4 w-full pb-10"
      style={{ fontFamily: "'Quicksand', sans-serif" }}
    >
      <SEOHead
        title="Eğlenceli Ekstralar ve Aktiviteler"
        description="İlkokul öğrenciler için hazırlanan eğlenceli İngilizce bulmacalar, oyunlar, mini testler ve ekstra öğrenme araçları."
      />
      {/* ana icerikleri */}

      {currentActiveId === 1 && (
        <True_False
          true_false={contentValue.true_false}
          picture={dynamicPicture}
          settab={settab}
        />
      )}
      {currentActiveId === 2 && (
        <Listen_find
          listen_find={contentValue.listen_find}
          picture={dynamicPicture}
          settab={settab}
        />
      )}
      {currentActiveId === 3 && (
        <Answer_question
          answer_question={contentValue.answer_question}
          picture={dynamicPicture}
          settab={settab}
        />
      )}
      {/* {currentActiveId === 4 && (
        <Description
          description={contentValue.description}
          picture={dynamicPicture}
          settab={settab}
        />
      )} */}
    </div>
  );
}

export default ExtraTaskPage;
